const GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE = 'GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE'
const SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE = 'SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE'

export {
    GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE,
    SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE
}
